// extracted by mini-css-extract-plugin
export default {"container":"CalloutBox-module__container__ggevX","callout":"CalloutBox-module__callout__poS9L"};